export default __webpack_public_path__ + "static/media/SCA0010.34I-36515_-21474_0.d4579b90.jpg";